<span class="{{ displayClass }}" [style.color]="color">
  @if(this.iconClass?.startsWith('stla')){
  <mat-icon svgIcon="{{ iconClass }}" class="size-{{ size }}"></mat-icon>
  } @else if(this.iconClass) {
  <mat-icon class="font-{{ size }}">{{ iconClass }}</mat-icon>
  } @else {
  <mat-icon [inline]="true">
    <img [src]="iconSrc" alt="icon" 
         data-aue-prop="icon"
         data-aue-type="media" 
         data-aue-label="icon" />
  </mat-icon>
  }
</span>